import React from 'react';
import { ROUTE_NAMES } from '../../Routes';
import { Helmet } from 'react-helmet-async';
import { Link, useLocation } from 'react-router-dom';

import P_1 from '../../assets/press/Press-1-1.png';
import P_2 from '../../assets/press/Press-2-1.webp';
import P_3 from '../../assets/press/Press-3-1.jpg';
import P_7 from '../../assets/press/Press-8-1.jpg';
import P_7_2 from '../../assets/press/Press-8-2.jpg';
import P_7_3 from '../../assets/press/Press-8-3.jpeg';
import P_7_4 from '../../assets/press/Press-8-4.jpg';

export default function PressPage7() {
  const location = useLocation();
  const canonicalUrl = `https://www.thestarlifegroup.com${location.pathname}`;

  const pressList = [
    {
      image: P_1,
      title:
        'Starlife: Construction Starts on ’21 Hollywood’ at 2100 N. Federal Highway, Hollywood, FL, 33020',
      link: ROUTE_NAMES.PRESS1,
    },
    {
      image: P_2,
      title:
        '21 Hollywood, a new 13-story mixed-use apartment development is coming to the heart of Hollywood',
      link: ROUTE_NAMES.PRESS2,
    },
    {
      image: P_3,
      title:
        'Exclusive & Iconic: Starlife Group’s 21 Hollywood Recognized as the Best in Luxury Real Estate',
      link: ROUTE_NAMES.PRESS3,
    },
  ];

  return (
    <div className='press-single-page'>
      <Helmet>
        <title>
          Starlife: Luxury at its finest: 21 Hollywood by Starlife Group wins
          prestigious industry award
        </title>
        <meta
          name='description'
          content='Stay updated with Starlife Group’s latest news, real estate insights, investment trends, and project announcements.'
        />
        <meta
          name='keywords'
          content='Starlife press, Real estate news, Luxury property updates, Real estate investment insights, Starlife Group announcements, Property market trends'
        />
        <link rel='canonical' href={canonicalUrl} />
      </Helmet>
      <div className='col-1'>
        <img src={P_7} alt='press-image' />
        <h2 className='press-page-title'>
          Luxury at its finest: 21 Hollywood by Starlife Group wins prestigious
          industry award
        </h2>
        <span className='author-name'>By LLM Reporters</span>
        <span className='author-name'>May 20, 2025</span>
        <Link
          to={
            'https://www.luxurylifestylemag.co.uk/property/luxury-at-its-finest-21-hollywood-by-starlife-group-wins-prestigious-industry-award/#google_vignette'
          }
        >
          <span className='author-name'>Source</span>
        </Link>

        <div className='press-page-content'>
          <p>
            In South Florida – where style meets sophistication – Starlife Group
            is redefining ultra-luxury living with its award-winning project, 21
            Hollywood. Celebrated by Luxury Lifestyle Awards as the Best Luxury
            Residential Development in Florida, USA, 21 Hollywood is more than
            just an upscale residential tower, it offers an iconic lifestyle for
            the global elite. Based in Miami, Starlife Group has a bold vision
            and a reputation for innovation, enhancing the standard for modern
            luxury and “making waves” in one of the world’s most dynamic real
            estate markets.{' '}
          </p>
          <p>
            The company has firmly established itself as one of the most and
            trusted names in the ultra-luxury sector. Headquartered in Miami – a
            city synonymous with glamour, innovation, and global investment –
            Starlife Group has become a symbol of excellence in high-end real
            estate.
          </p>
          <img src={P_7_2} alt='press-image' />
          <p style={{ fontWeight: '600' }}>
            A legacy of excellence and innovation
          </p>
          <p>
            Founded by the dynamic duo Gevorg Shahbazyan and Arman Shahbazyan,
            Starlife Group has mapped out an enviable niche in the luxury
            property market. Their vision was simple yet profound: to redefine
            urban living by blending visionary design with impeccable
            craftsmanship. Their efforts have culminated in the awe-inspiring 21
            Hollywood project which encapsulates the company’s passion for
            quality, modernization, and the creation of elevated lifestyles.
          </p>
          <p>
            Starlife Group’s deep knowledge of the South Florida luxury market
            is exceptional. Operating primarily in Miami, one of the world’s
            most vibrant real estate hubs, the company has refined its expertise
            through years of experience. Miami’s unique blend of cultural
            diversity, economic vitality, and pristine coastal beauty provides
            the perfect backdrop for luxury developments that cater to
            high-net-worth individuals (HNWIs) and savvy international investors
            alike. With 21 Hollywood as its crown jewel, Starlife Group has set
            new standards in sophisticated design, premium amenities, and
            strategic location planning.
          </p>
          <p style={{ fontWeight: '600' }}>
            21 Hollywood: The epitome of ultra-luxury
          </p>
          <p>
            Located between Miami and Fort Lauderdale, 21 Hollywood epitomises
            lavish living. The development is an intoxicating blend of modern
            architectural brilliance and timeless elegance. Featuring
            state-of-the-art design, premium finishes, and breathtaking Atlantic
            Ocean views, 21 Hollywood is designed for those who demand nothing
            but the best. The project is meticulously presented to serve a
            clientele that values exclusivity, superior craftsmanship, and an
            investment that appreciates over time.
          </p>
          <p>
            The development caters to a discerning, HNWI audience seeking more
            than just a residence, but a distinctive and elevated lifestyle.
            With an emphasis on privacy, security, and an array of luxury
            amenities, 21 Hollywood offers an exclusive ecosystem designed to
            foster a sense of community among the elite, offering living
            experience that synchronises modern luxury with the serenity of
            waterfront living.
          </p>
          <img src={P_7_3} alt='press-image' />
          <p style={{ fontWeight: '600' }}>
            Expertise in international deals and local markets
          </p>
          <p>
            One of Starlife Group’s defining strengths is its ability to
            facilitate international deals, making the dream of owning a slice
            of Miami’s ultra-luxury lifestyle accessible to global investors.
            With a well-established network of international partners and a
            reputation built on trust and transparency, the company navigates
            the complexities of cross-border transactions with ease. This
            expertise not only attracts international investors but gives them
            confidence that their assets are managed with exceptional
            professionalism and meticulous attention to detail.
          </p>
          <p>
            The company’s local market acumen is equally impressive. Starlife
            Group leverages its extensive knowledge of Miami’s dynamic real
            estate trends to offer luxury properties that are strategically
            located for maximum growth and investment returns. Their focus on
            the best in luxury residential development is evident at its 21
            Hollywood project – from the choice of location and architectural
            design to the integration of modern technology and sustainable
            practices.
          </p>
          <p style={{ fontWeight: '600' }}>
            Commitment to client satisfaction and superior service
          </p>
          <p>
            Starlife Group’s drive for excellence extends beyond the tangible
            aspects of their developments. The company provides a bespoke
            experience for every client, ensuring that the process is as refined
            and exclusive as the properties themselves. With a team of seasoned
            professionals, including real estate brokers, legal advisors, and
            financial experts, Starlife Group offers end-to-end support to its
            clients, making luxury South Florida living a reality without the
            hassle.
          </p>
          <img src={P_7_4} alt='press-image' />
          <p style={{ fontWeight: '600' }}>
            Discover the future of luxury living
          </p>
          <p>
            With an impressive portfolio that spans residential, commercial, and
            mixed-use developments, Starlife Group is a visionary force that
            continues to shape South Florida’s skyline and the future of luxury
            living. For those ready to experience the ultimate in high-end real
            estate, Starlife Group and its award-winning project, 21 Hollywood,
            offer an exclusive opportunity to invest in a lifestyle defined by
            sophistication, ingenuity, and lasting value.
          </p>
          <p>
            Explore a masterpiece of luxury living. Visit thestarlifegroup.com
            to learn more about 21 Hollywood and discover why Starlife Group is
            a trusted name in ultra-luxury real estate.
          </p>
        </div>
      </div>
      <div className='col-2'>
        <div className='sticky-press-list'>
          <h3>Press Articles</h3>
          {pressList.map((item, idx) => (
            <Link to={item.link} key={idx}>
              <div className='other-press-card'>
                <img src={item.image} alt={`press-${idx}`} />
                <p>{item.title}</p>
              </div>
            </Link>
          ))}
          <Link to={ROUTE_NAMES.PRESS}>
            <button className='view-all-press-btn'>View All</button>
          </Link>
        </div>
      </div>
    </div>
  );
}
